import "../../styles/ui/hotelWidget.scss";

const HotelWidget = ({ placement = "desktop" }) => {
  const containerId = `tl-search-form-${placement}`;

  return (
    <div id={`block-search-${placement}`} className={`tl-search ${placement}`}>
      <div id={containerId} className="tl-container">
        <a
          href="https://www.travelline.ru/products/tl-hotel/"
          rel="nofollow noopener noreferrer"
          target="_blank"
        >
          TravelLine
        </a>
      </div>
    </div>
  );
};

export default HotelWidget;
